import React, { useContext, useEffect, useState } from "react";
import { ProductContext } from "../../../stores/session";
import request from "../../../helpers/request";
import endpoints from "../../../helpers/endpoints";

export default function useStatusFilter({ selectedWholesaler, selectedAdcGroup, selectedDate }) {
    const { apiPrefix } = useContext(ProductContext)
    const [workflowCounts, setWorkflowCounts] = useState([])
    const [selectedStatus, setSelectedStatus] = useState('New');

    useEffect(() => {
        getWorkflowCounts()
    }, [])

    const getWorkflowCounts = () => {
        request(true).get(endpoints[`${apiPrefix}_WF_COUNTS`], {
            doesCancel: true,
            params: {
                selectedWholesaler: selectedWholesaler,
                selectedDate: selectedDate,
                selectedAdcGroup: selectedAdcGroup,
                status: selectedStatus
            }
        }).then(r => {
            setWorkflowCounts(r.data)
        })
    }

    return { workflowCounts, getWorkflowCounts, selectedStatus, setSelectedStatus }
}